'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import * as React from 'react';
import { useStore } from '@mui/x-internals/store';
import { useChatRuntimeContext } from "../internals/useChatRuntimeContext/index.js";
import { chatSelectors } from "../selectors/index.js";
import { useChatStore } from "./useChatStore.js";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

const noopAsync = async () => {};
const noopAsyncWithArg = async _arg => {};
export function useChat() {
  const store = useChatStore();
  const {
    actions
  } = useChatRuntimeContext();
  const selectMessages = chatSelectors.messages;
  const selectConversations = chatSelectors.conversations;
  const selectActiveConversationId = chatSelectors.activeConversationId;
  const selectIsStreaming = chatSelectors.isStreaming;
  const selectHasMoreHistory = chatSelectors.hasMoreHistory;
  const selectError = chatSelectors.error;
  const messages = useStore(store, selectMessages);
  const conversations = useStore(store, selectConversations);
  const activeConversationId = useStore(store, selectActiveConversationId);
  const isStreaming = useStore(store, selectIsStreaming);
  const hasMoreHistory = useStore(store, selectHasMoreHistory);
  const error = useStore(store, selectError);
  return React.useMemo(() => ({
    messages,
    conversations,
    activeConversationId,
    isStreaming,
    hasMoreHistory,
    error,
    sendMessage: actions.sendMessage,
    stopStreaming: actions.stopStreaming,
    loadMoreHistory: actions.loadMoreHistory,
    setActiveConversation: actions.setActiveConversation,
    retry: actions.retry,
    setError: actions.setError,
    addToolApprovalResponse: actions.addToolApprovalResponse,
    reloadConversations: process.env.NODE_ENV !== 'production' ? async () => {
      throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: reloadConversations is not yet implemented.\n' + 'This method is a planned API stub. Remove the call until it is implemented.' : _formatErrorMessage(250));
    } : noopAsync,
    reloadMessages: process.env.NODE_ENV !== 'production' ? async _arg => {
      throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: reloadMessages is not yet implemented.\n' + 'This method is a planned API stub. Remove the call until it is implemented.' : _formatErrorMessage(251));
    } : noopAsyncWithArg,
    reconnectRealtime: process.env.NODE_ENV !== 'production' ? async () => {
      throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Chat: reconnectRealtime is not yet implemented.\n' + 'This method is a planned API stub. Remove the call until it is implemented.' : _formatErrorMessage(252));
    } : noopAsync
  }), [actions.addToolApprovalResponse, actions.loadMoreHistory, actions.retry, actions.sendMessage, actions.setActiveConversation, actions.setError, actions.stopStreaming, activeConversationId, conversations, error, hasMoreHistory, isStreaming, messages]);
}